var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout-full',{staticClass:"reset-password-view",attrs:{"breadcrumb":_vm.breadcrumb},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Изменение пароля")]},proxy:true}])},[_c('reset-password-form',{staticClass:"reset-password-view__form",attrs:{"user-id":_vm.userId,"code":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }